module.exports = __webpack_public_path__ + "static/fanta-2-dd8d1f94d0276f9d61c27a773f5e0862.jpg";